/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var debounce = (function (fn, time) {
  var timeout;
  return function internal() {
    var _arguments = arguments,
      _this = this;
    var functionCall = function functionCall() {
      return fn.apply(_this, _arguments);
    }; // eslint-disable-line prefer-rest-params

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
});

export { debounce as default };
